import React, { useState } from 'react';
import { Layout, Tooltip } from 'antd';
import { CloseOutlined, MenuOutlined, DownOutlined } from '@ant-design/icons';

import { ReactComponent as EllinikiDimokratia } from 'assets/icons/logo-gov2.svg';
import { ReactComponent as Ellada20Revert } from 'assets/icons/ellada_2_0_alone_white.svg';
import { ReactComponent as Operator } from 'assets/icons/operator_icon.svg';
// import { loginUrl } from 'utils';

const { Header } = Layout;

const HeaderLanding = () => {
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <Header className="app-layout__header_landing">
      <div className="header-left">
        <EllinikiDimokratia
          className="app-layout__logo-gr-democracy"
          onClick={() => window.open('https://www.gov.gr/', '_blank')}
        />
      </div>
      <div className="header-right mt-1">
        <div>
          <Ellada20Revert
            className="app-layout__logo-gr-2-0"
            onClick={() => window.open('https://greece20.gov.gr/', '_blank')}
          />
        </div>
        <div className="header-links mt-1">
          <div className="header-tooltip-operator">
            <Tooltip
              className="mt-3 ml-1"
              overlayClassName="custom-tooltip helpdesk-tooltip"
              placement="bottomRight"
              title={
                <div class="header-tooltip-operator-left">
                  <div class="header-tooltip-operator-left-span">
                    <div
                      style={{
                        textAlign: 'left',
                        display: 'block',
                        width: 'fit-content',
                      }}
                    >
                      <p className='helpdesk-tooltip-paragraph'>
                      Αν οι απορίες σας δεν απαντήθηκαν από τις
                      Πληροφορίες, μπορείτε να μας ρωτήσετε μέσω email εδώ:
                      </p>
                      <p className='helpdesk-tooltip-paragraph'>
                        <a href="mailto:gigabit@ktpae.gr">
                        gigabit@ktpae.gr
                        </a>
                      </p>
                      <p className='helpdesk-tooltip-paragraph'>
                        ή να καλέσετε στο Κέντρο Εξυπηρέτησης της δράσης
                        (9:00-17:00) στο 210 2151029
                      </p>
                      {/* <p className='helpdesk-tooltip-paragraph'>
                      2102151059
                      </p> */}
                    </div>
                  </div>
                </div>
              }
            >
              <div className="operator">
                <Operator
                  className="operator-icon"
                  style={{ cursor: 'pointer' }}
                />
                <DownOutlined className="operator-downoutline" />
              </div>
            </Tooltip>
          </div>
        </div>
        <div className="header-icon-mobile">
          {!showDropdown && (
            <MenuOutlined onClick={() => setShowDropdown(true)} />
          )}
          {showDropdown && (
            <CloseOutlined onClick={() => setShowDropdown(false)} />
          )}
        </div>
        {showDropdown && (
          <div className="header-links-mobile">
            <Operator className="operator-icon" />
            <div className="header-paragraph">
              <p>
                Αν οι απορίες σας δεν απαντήθηκαν από τις Πληροφορίες,
                μπορείτε να μας ρωτήσετε μέσω email εδώ:&nbsp;
                <br />
                <a href="gigabit@ktpae.gr">
                gigabit@ktpae.gr
                </a>{' '}
                <br />
                ή να καλέσετε στο Κέντρο
                <br />
                Εξυπηρέτησης της δράσης (09:00 – 17:00) <br />
                <a href="tel:210 2151029">210 2151029</a>
              </p>
            </div>
            <div className="header-paragraph">
              {/* <a onClick={() => setShowBot(!showBot)}>
                <img src={bot_img} alt="bot_img" width={100} height={100} />
              </a> */}
            </div>
          </div>
        )}
      </div>
    </Header>
  );
};

export default HeaderLanding;
